/* eslint react/forbid-prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import Header from 'components/Header';
import Footer from 'components/Footer';
import classes from './Layout.module.scss';

const Layout = ({ children }) => (
  <div className={classes.layout}>
    <Header />
    <div className={classes.contentContainer}>
      <div className={classes.content}>{children}</div>
    </div>
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.array.isRequired,
};

export default Layout;
